import {
    ALT,
    BACKSPACE,
    CONTROL,
    DELETE,
    DOWN_ARROW,
    END,
    HOME,
    INSERT,
    LEFT_ARROW,
    META,
    PAGE_DOWN,
    PAGE_UP,
    PERIOD,
    RIGHT_ARROW,
    SEMICOLON,
    TAB,
    UP_ARROW,
} from '@angular/cdk/keycodes';
import { FiCustomValidatorPatterns } from '@fi-shared/fi-custom-validator-patterns/fi-custom-validator-patterns';

interface IValidateInputNumberStringArgs {
    event: KeyboardEvent;
    isDecimalAllowed?: boolean;
    isColonAllowed?: boolean;
    extraKeyCodes?: number[];
}

export function fiValidateInputNumberString(args: IValidateInputNumberStringArgs) {
    let target_key_codes: number[] = [
        TAB,
        CONTROL,
        META,
        ALT,
        LEFT_ARROW,
        UP_ARROW,
        RIGHT_ARROW,
        DOWN_ARROW,
        INSERT,
        DELETE,
        BACKSPACE,
        PAGE_UP,
        PAGE_DOWN,
        HOME,
        END,
    ];

    if (args.isDecimalAllowed) {
        target_key_codes.push(PERIOD);
    }

    if (target_key_codes.includes(args.event.keyCode)) return;

    if (args.isColonAllowed && args.event.shiftKey && args.event.keyCode === SEMICOLON) return;

    // note: non-number keys when metaKey/ctrlKey is set to true to allow user copy, cut, paste etc.
    if (Number.isNaN(+args.event.key) && !(args.event.metaKey || args.event.ctrlKey)) args.event.preventDefault();
}

export function fiValidatePasteNumberString(
    event: ClipboardEvent,
    validatorPattern: FiCustomValidatorPatterns = FiCustomValidatorPatterns.PhoneNumberWithoutCountryCode,
) {
    const pasteText: string = event.clipboardData.getData('text');
    const regExp: RegExp = new RegExp(validatorPattern);
    if (!regExp.test(pasteText)) event.preventDefault();
}

export function fiValidateDropNumberString(
    event: DragEvent,
    validatorPattern: FiCustomValidatorPatterns = FiCustomValidatorPatterns.PhoneNumberWithoutCountryCode,
) {
    const dropText: string = event.dataTransfer.getData('text');
    const regExp: RegExp = new RegExp(validatorPattern);
    if (!regExp.test(dropText)) event.preventDefault();
}
